import styled from 'styled-components'
import css from '@styled-system/css'

export const Container = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;

  ${css({
    color: 'gray.6',
    fontSize: 0,
  })}
`
export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.gray[6]};
  text-decoration: none;

  &:visited {
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }
`
